import type { AxiosResponse } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

import { PEOPLE_API_ROUTES } from '@/api-routes';
import { axiosInstance } from '@/axios';
import { QUERY_KEY } from '@/features/ManageContacts/common';

type Data = { people_id: string; people_name: string; people_priority: string };

export const useEditContact = () => {
  const queryClient = useQueryClient();

  return useMutation<AxiosResponse, unknown, Data>(
    (data) =>
      axiosInstance.post(PEOPLE_API_ROUTES.editPeople(data.people_id), {
        name: data.people_name,
        priority: data.people_priority,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QUERY_KEY]);
      },
    }
  );
};
